import { Info } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export default function DemoBanner({ isDemo }) {
  const { t } = useI18n();
  if (!isDemo) return null;
  return (
    <div
      className="flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-medium"
      style={{ background: "#FEF7E0", border: "1px solid #FDE293", color: "#8a5a00" }}
      role="status"
      data-testid="demo-banner"
    >
      <Info size={16} aria-hidden="true" />
      {t("demo_banner")}
    </div>
  );
}
